import 'whatwg-fetch';
import { buildRequestUrl } from './build-request-url';
import { setupRequestOptions } from './setup-request-options';
import { parseSuccessResponse } from './parse-success-response';
import { parseErrorResponse } from './parse-error-response';
import logger from '../logger';

export interface CustomRequestProps {
  url: string;
  params?: Record<string, unknown>;
  method: string;
  headers: RequestInit['headers'];
  options: RequestInit;
}

export interface CustomRequestResponse {
  status: number;
  message: string;
  errors?: Record<string, string[]>;
  response?: unknown;
}

export const customRequest = async (
  props: CustomRequestProps,
): Promise<CustomRequestResponse> => {
  const { url, params, method, headers, options } = props;
  const requestUrl = buildRequestUrl(url, params, method);
  const requestOptions = setupRequestOptions(method, headers, options, params);

  try {
    const response = await fetch(requestUrl, requestOptions);

    if (response.ok) {
      return await parseSuccessResponse(response);
    }

    return await parseErrorResponse(response);
  } catch (error: unknown) {
    // Log the error with proper type checking
    if (error instanceof Error) {
      logger.error(`Network error: ${error.message}`);
    } else {
      logger.error('Unknown error occurred', error);
    }

    // Handle case where error might be an API error with response
    if (
      typeof error === 'object' &&
      error !== null &&
      'message' in error
    ) {
      throw error;
    }

    // The eslint warning has been disabled to conform with the original request.js
    // eslint-disable-next-line no-throw-literal
    throw {
      status: 500,
      message: 'Internal Server Error',
    };
  }
};
